<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/7fZi1i/tc-custom/9780857901781.jpg?1718183455239" alt="This image is the cover for the book Jessie's Journey"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Jessie's Journey
      </h1>
      <p class="bookDescription body article font2">
        <b>A “remarkable” account of a family’s years wandering Scotland and England in a bus, living the traditional life of their people (<i>Caledonia</i>).</b><br/>  <br/> From the ages of five to fifteen, Jess Smith lived with her parents and sisters and a mongrel dog in an old blue bus. They traveled the length and breadth of Scotland, and much of England too, stopping here and there until they were moved on by the local authorities or driven by their own instinctive need to travel. By campfires, under the unchanging stars, they brewed up tea, telling stories and singing songs late into the night.<br/>  <br/> The “unforgettable story of a Scottish Gypsy girl” (Maggie Smith Bendle, civil rights activist), <i>Jessie’s Journey</i> describes what it was like to be one of the last of the traditional travelling folk. It is not an idyllic tale, but despite the ever-present threat of bigoted abuse and the challenges of scattered schooling, humor and laughter run throughout a childhood teeming with unforgettable characters.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jess Smith
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Birlinn Ltd
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?fa67c366